<button class="border text-black px-2 py-1" (click)="toggle()">
    <fa-icon icon="bars"></fa-icon>
</button>
